import { render, staticRenderFns } from "./GenerateClinicCode.vue?vue&type=template&id=74ef4b66&scoped=true"
import script from "./GenerateClinicCode.vue?vue&type=script&lang=js"
export * from "./GenerateClinicCode.vue?vue&type=script&lang=js"
import style0 from "./GenerateClinicCode.vue?vue&type=style&index=0&id=74ef4b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ef4b66",
  null
  
)

export default component.exports